import React, { useContext } from 'react';
import { useRepeatedSection } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import JointOwnerPIDetails from './JointOwnerPIDetails';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const JointOwnerPISection = () => {
  const {
    appState: {
      store: { additionalCustomers = [] }
    },
    formProps: {
      jointOwnerFirstName,
      jointOwnerMiddleName,
      jointOwnerLastName,
      jointOwnerDob,
      jointOwnerCitizenship,
      jointOwnerSsn
    }
  } = useContext(FlowContext);

  const defaults = {
    people: additionalCustomers.map(person => ({
      [jointOwnerFirstName.name]: person.name.firstName,
      [jointOwnerMiddleName.name]: person.name.middleName,
      [jointOwnerLastName.name]: person.name.lastName,
      [jointOwnerDob.name]: person.dob,
      [jointOwnerCitizenship.name]: person.citizenship,
      [jointOwnerSsn.name]: person.taxID
    }))
  };

  const { sections, addSection } = useRepeatedSection('people', defaults);

  return (
    <>
      <div className="add-section-button">
        Joint Owner(s)
        <hr />
        {sections.length < 3 && (
          <MFBeaconButton
            type="button"
            id="addJointOwnerBtn"
            data-name={generateGeneralTestID(
              'JointOwnerPI',
              'AddJointOwnerButton'
            )}
            onClick={addSection}
            variant="tertiary"
            label="+ Add Joint Owner"
          />
        )}
      </div>
      <div className="sections">
        {sections.map(({ key, getDefault, makeName, removeSection }) => {
          return (
            <JointOwnerPIDetails
              key={key}
              sectionKey={key}
              getDefault={getDefault}
              makeName={makeName}
              removeSection={removeSection}
            />
          );
        })}
      </div>
    </>
  );
};

export default JointOwnerPISection;
